export const professionalLayouts: Record<string, string[][]> = {
  "citrus-bloom": [
    [
      "summary",
      "experience",
      "education",
      "projects",
      "awards",
      "publications",
      "volunteer",
      "references",
      "certifications",
    ],
    ["profiles", "languages", "skills", "interests"],
  ],
  "plum-timeline": [
    [
      "summary",
      "education",
      "experience",
      "projects",
      "awards",
      "publications",
      "volunteer",
      "references",
    ],
    ["profiles", "skills", "languages", "interests", "certifications"],
  ],
  "mono-content": [
    [
      "summary",
      "skills",
      "experience",
      "education",
      "certifications",
      "awards",
      "projects",
      "profiles",
      "volunteer",
      "publications",
      "languages",
      "interests",
      "references",
    ],
    [],
  ],
  "linen-ledger": [
    [
      "experience",
      "references",
      "projects",
      "profiles",
      "awards",
      "publications",
      "volunteer",
      "skills",
      "languages",
      "interests",
    ],
    ["summary", "education", "certifications"],
  ],
  "charcoal-monogram": [
    [
      "summary",
      "experience",
      "references",
      "projects",
      "awards",
      "publications",
      "volunteer",
      "interests",
    ],
    ["profiles", "education", "skills", "languages", "certifications"],
  ],
  "cobalt-balance": [
    [
      "summary",
      "experience",
      "projects",
      "references",
      "profiles",
      "certifications",
      "awards",
      "publications",
      "volunteer",
    ],
    ["education", "skills", "languages", "interests"],
  ],
  "royal-line": [
    [
      "summary",
      "experience",
      "education",
      "skills",
      "languages",
      "interests",
      "profiles",
      "projects",
      "certifications",
      "awards",
      "publications",
      "volunteer",
      "references",
    ],
    [],
  ],
  "silver-ledger": [
    [
      "summary",
      "experience",
      "education",
      "skills",
      "languages",
      "interests",
      "profiles",
      "projects",
      "certifications",
      "awards",
      "publications",
      "volunteer",
      "references",
    ],
    [],
  ],
  "navy-summit": [
    [
      "summary",
      "experience",
      "education",
      "references",
      "profiles",
      "projects",
      "certifications",
      "awards",
      "publications",
      "volunteer",
    ],
    ["skills", "languages", "interests"],
  ],
  "dune-flow": [
    [
      "summary",
      "experience",
      "education",
      "skills",
      "projects",
      "certifications",
      "awards",
      "publications",
      "volunteer",
      "references",
    ],
    ["profiles", "languages", "interests"],
  ],
  "blue-horizon": [
    [
      "summary",
      "experience",
      "education",
      "projects",
      "awards",
      "publications",
      "volunteer",
      "references",
      "certifications",
    ],
    ["profiles", "languages", "skills", "interests"],
  ],
  "slate-ledger": [
    [
      "summary",
      "experience",
      "projects",
      "references",
      "awards",
      "publications",
      "volunteer",
      "interests",
    ],
    ["profiles", "education", "skills", "languages", "certifications"],
  ],
  "editorial-muse": [
    [
      "summary",
      "experience",
      "education",
      "skills",
      "projects",
      "certifications",
      "awards",
      "publications",
      "volunteer",
      "references",
    ],
    ["profiles", "languages", "interests"],
  ],
  "sand-profile": [
    [
      "summary",
      "education",
      "experience",
      "projects",
      "awards",
      "publications",
      "volunteer",
      "references",
      "certifications",
    ],
    ["profiles", "languages", "skills", "interests"],
  ],
  "code-clarity": [
    [
      "summary",
      "experience",
      "projects",
      "education",
      "volunteer",
      "awards",
      "publications",
      "references",
    ],
    ["profiles", "skills", "languages", "certifications", "interests"],
  ],
  "marketing-pulse": [
    [
      "summary",
      "experience",
      "projects",
      "awards",
      "publications",
      "volunteer",
      "references",
      "education",
    ],
    ["profiles", "skills", "languages", "certifications", "interests"],
  ],
  "people-first": [
    [
      "summary",
      "experience",
      "projects",
      "awards",
      "publications",
      "volunteer",
      "references",
      "interests",
    ],
    ["profiles", "skills", "education", "certifications", "languages"],
  ],
  "structural-line": [
    [
      "experience",
      "projects",
      "education",
      "awards",
      "publications",
      "volunteer",
      "references",
      "interests",
    ],
    ["profiles", "summary", "skills", "certifications", "languages"],
  ],
  "clinical-calm": [
    [
      "summary",
      "experience",
      "education",
      "certifications",
      "interests",
      "awards",
      "publications",
      "volunteer",
      "references",
      "projects",
    ],
    ["profiles", "skills", "languages"],
  ],
  "sales-focus": [
    [
      "summary",
      "experience",
      "projects",
      "awards",
      "publications",
      "volunteer",
      "references",
      "education",
    ],
    ["profiles", "skills", "languages", "certifications", "interests"],
  ],
  "account-balance": [
    [
      "summary",
      "experience",
      "education",
      "projects",
      "awards",
      "publications",
      "volunteer",
      "references",
    ],
    ["profiles", "skills", "certifications", "languages", "interests"],
  ],
  "legal-distinction": [
    [
      "summary",
      "experience",
      "education",
      "certifications",
      "publications",
      "awards",
      "volunteer",
      "references",
      "projects",
    ],
    ["profiles", "skills", "languages", "interests"],
  ],
  "fiscal-arch": [
    [
      "summary",
      "experience",
      "education",
      "certifications",
      "projects",
      "awards",
      "publications",
      "volunteer",
      "references",
    ],
    ["profiles", "skills", "languages", "interests"],
  ],
  "soft-contour": [
    [
      "summary",
      "experience",
      "education",
      "projects",
      "certifications",
      "awards",
      "publications",
      "volunteer",
      "references",
    ],
    ["profiles", "skills", "languages", "interests"],
  ],
  "sage-orbit": [
    [
      "summary",
      "experience",
      "projects",
      "awards",
      "publications",
      "volunteer",
      "references",
      "languages",
      "interests",
      "education",
    ],
    ["profiles", "skills", "certifications"],
  ],
  "azure-frame": [
    [
      "summary",
      "experience",
      "certifications",
      "awards",
      "volunteer",
      "references",
      "publications",
      "profiles",
      "education",
    ],
    ["skills", "projects", "languages", "interests"],
  ],
  "forest-frame": [
    [
      "summary",
      "experience",
      "projects",
      "awards",
      "certifications",
      "publications",
      "volunteer",
      "references",
      "education",
    ],
    ["profiles", "skills", "languages", "interests"],
  ],
  "brand-mocha": [
    [
      "profiles",
      "experience",
      "skills",
      "projects",
      "certifications",
      "awards",
      "publications",
      "volunteer",
      "references",
      "education",
    ],
    ["summary", "languages", "interests"],
  ],
  "project-flow": [
    [
      "summary",
      "experience",
      "projects",
      "interests",
      "awards",
      "publications",
      "volunteer",
      "references",
    ],
    ["profiles", "skills", "education", "languages", "certifications"],
  ],
  "fresh-start": [
    [
      "summary",
      "experience",
      "projects",
      "education",
      "awards",
      "publications",
      "volunteer",
      "references",
    ],
    ["profiles", "skills", "certifications", "languages", "interests"],
  ],
  "blue-wave": [
    [
      "summary",
      "education",
      "experience",
      "projects",
      "volunteer",
      "awards",
      "certifications",
      "publications",
      "references",
    ],
    ["profiles", "skills", "languages", "interests"],
  ],
};

export const preserveCustomSections = (layout: string[][][], customIds: string[]): string[][][] => {
  const result = layout.map((page) => page.map((column) => [...column]));
  const existing = new Set(result.flat(2));
  for (const id of customIds) {
    const key = `custom.${id}`;
    if (!existing.has(key)) result[0][0].push(key);
  }
  return result;
};

const mainSectionOverrides: Record<string, string[]> = {
  "slate-ledger": ["interests"],
  "marketing-pulse": ["education"],
  "sales-focus": ["education"],
  "forest-frame": ["education"],
  "charcoal-monogram": ["interests"],
  "linen-ledger": ["skills", "languages", "interests"],
  "azure-frame": ["education"],
  "clinical-calm": ["interests"],
  "brand-mocha": ["education"],
  "sage-orbit": ["languages", "interests", "education"],
};

export const normalizeTemplateLayout = (template: string, layout: string[][][]): string[][][] => {
  const main = mainSectionOverrides[template] ?? [];
  const side =
    template === "clinical-calm"
      ? ["skills"]
      : ["marketing-pulse", "sales-focus", "forest-frame", "account-balance"].includes(template)
        ? ["interests"]
        : [];
  const moved = [...main, ...side];
  if (!moved.length || !layout[0]) return layout;
  const present = new Set(layout.flat(2));
  const result = layout.map((page) =>
    page.map((column) => column.filter((key) => !moved.includes(key))),
  );
  result[0][0].push(...main.filter((key) => present.has(key)));
  result[0][1].push(...side.filter((key) => present.has(key)));
  return result;
};
